import { render, staticRenderFns } from "./budget-quarter.vue?vue&type=template&id=bc27e1e0&"
import script from "./budget-quarter.vue?vue&type=script&lang=js&"
export * from "./budget-quarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports